import { useState, useEffect } from "react";
import axios from "../../axios";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import handleApiError from "../../utils/handleApiError";
import { STORAGE_URL } from "../../constants";

export default function LoginPage() {
    const [form, setForm] = useState({ email: "", password: "" });
    const [error, setError] = useState("");
    const { setUser } = useAuth();
    const navigate = useNavigate();
    const [setting, setSetting] = useState(null);

    useEffect(() => {
    if (setUser && setUser.role === "admin") {
        navigate("/admin/categories");
    }
    }, [setUser]);

    useEffect(() => {
        axios.get("/settings").then((res) => setSetting(res.data));
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        try {
            const res = await axios.post("/login", form);
            const { token, user } = res.data;

            // Simpan token ke localStorage (interceptor akan handle header)
            localStorage.setItem("token", token);

            // Simpan user ke context
            setUser(user);

            // Redirect ke admin
            navigate("/admin/categories");
        } catch (err) {
            console.error("Admin login error:", err);
            setError(handleApiError(err));
        }
    };


    useEffect(() => {
        const scripts = [
            "jquery-3.7.1.min.js",
            
            "boostrap.bundle.min.js",
            "phosphor-icon.js",
            "file-upload.js",
            "plyr.js",
            // "https://cdn.datatables.net/2.0.8/js/dataTables.min.js",
            "full-calendar.js",
            "jquery-ui.js",
            "editor-quill.js",
            "apexcharts.min.js",
            // "calendar.js",
            "jquery-jvectormap-2.0.5.min.js",
            // "jquery-jvectormap-world-mill-en.js",
            "main.js",
          
        ];
    
        // Tambahkan script satu per satu dengan async: false
        const scriptTags = [];
        scripts.forEach((src) => {
          const script = document.createElement("script");
          script.src = `/admin-template/js/${src}`;
          script.async = false; // Penting agar urutan terjaga!
          document.body.appendChild(script);
          scriptTags.push(script);
        });

        return () => {
      scriptTags.forEach((script) => {
        if (document.body.contains(script)) document.body.removeChild(script);
      });
    };
  }, []);

    return (
        <>
        <link rel="stylesheet" href="/admin-template/css/bootstrap.min.css" />
      <link rel="stylesheet" href="/admin-template/css/file-upload.css" />
      <link rel="stylesheet" href="/admin-template/css/plyr.css" />
      <link rel="stylesheet" href="/admin-template/css/full-calendar.css" />
      <link rel="stylesheet" href="/admin-template/css/jquery-ui.css" />
      <link rel="stylesheet" href="/admin-template/css/editor-quill.css" />
      <link rel="stylesheet" href="/admin-template/css/apexcharts.css" />
        <link rel="stylesheet" href="/admin-template/css/jquery-jvectormap-2.0.5.css" />
        <link rel="stylesheet" href="/admin-template/css/jquery-jvectormap-world-mill.css" />
      <link rel="stylesheet" href="/admin-template/css/main.css" />

        
        <section className="auth d-flex">
            <div className="auth-left bg-main-50 flex-center p-24">
                <img src={`${STORAGE_URL}${setting?.logo}`} alt=""/>
            </div>
            <div className="auth-right py-40 px-24 flex-center flex-column">
                <div className="auth-right__inner mx-auto w-100">
                    <a href="index.html" className="auth-right__logo">
                        <h3>{setting?.site_name}</h3>
                    </a>
                    <h2 className="mb-8">Welcome Back! &#128075;</h2>
                    <p className="text-gray-600 text-15 mb-32">Please sign in to your account and start the adventure</p>
                    {error && <div className="alert alert-danger mb-24">{error}</div>}
                    <form onSubmit={handleSubmit}>
                        <div className="mb-24">
                            <label className="form-label mb-8 h6">Email</label>
                            <div className="position-relative">
                                <input className="form-control py-11 ps-40" type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
                                <span className="position-absolute top-50 translate-middle-y ms-16 text-gray-600 d-flex"><i className="ph ph-user"></i></span>
                            </div>
                        </div>
                        <div className="mb-24">
                            <label className="form-label mb-8 h6">Current Password</label>
                            <div className="position-relative">
                                <input className="form-control py-11 ps-40" type="password" placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
                                <span className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y ph ph-eye-slash" id="#current-password"></span>
                                <span className="position-absolute top-50 translate-middle-y ms-16 text-gray-600 d-flex"><i className="ph ph-lock"></i></span>
                            </div>
                        </div>
                        {/* <div className="mb-32 flex-between flex-wrap gap-8">
                            <div className="form-check mb-0 flex-shrink-0">
                                <input className="form-check-input flex-shrink-0 rounded-4" type="checkbox" value="" id="remember" />
                                <label className="form-check-label text-15 flex-grow-1" for="remember">Remember Me </label>
                            </div>
                            <a href="forgot-password.html" className="text-main-600 hover-text-decoration-underline text-15 fw-medium">Forgot Password?</a>
                        </div> */}
                        <button type="submit" className="btn btn-main rounded-pill w-100">Sign In</button>
                        {/* <p className="mt-32 text-gray-600 text-center">New on our platform?
                            <a href="sign-up.html" className="text-main-600 hover-text-decoration-underline">Create an account</a>
                        </p> */}

                        {/* <div className="divider my-32 position-relative text-center">
                            <span className="divider__text text-gray-600 text-13 fw-medium px-26 bg-white">or</span>
                        </div>

                        <ul className="flex-align gap-10 flex-wrap justify-content-center">
                            <li>
                                <a href="https://www.facebook.com" className="w-38 h-38 flex-center rounded-6 text-facebook-600 bg-facebook-50 hover-bg-facebook-600 hover-text-white text-lg">
                                    <i className="ph-fill ph-facebook-logo"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.twitter.com" className="w-38 h-38 flex-center rounded-6 text-twitter-600 bg-twitter-50 hover-bg-twitter-600 hover-text-white text-lg">
                                    <i className="ph-fill ph-twitter-logo"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.google.com" className="w-38 h-38 flex-center rounded-6 text-google-600 bg-google-50 hover-bg-google-600 hover-text-white text-lg">
                                    <i className="ph ph-google-logo"></i>
                                </a>
                            </li>
                        </ul> */}
                        
                    </form>
                </div>
            </div>
        </section>
        </>
    )
}
